module.exports = __webpack_public_path__ + "static/media/gbd_2020.6a83efa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gbd_2020.png
// module id = 227
// module chunks = 2